import React from "react";

import styles from "./devMenu.module.scss";
import authService from "../../../utils/services/authService";
import logo from "../../../assets/images/Jobal.svg";
import { NavLink } from "react-router-dom";

const DevMenu = ({ userData, setIsNavOpen }) => {
  const linkClickHandle = () => {
    setIsNavOpen((prev) => !prev);
  };

  const logoutclickHandle = () => {
    authService.logoutUser();
  };

  return (
    <section className={styles.devMenu}>
      <img className={styles.menuLogo} src={logo} alt="" />

      <section className={styles.navLinks}>
        {userData.role === "developer" && userData.createdProfile !== true ? (
          <>
            <NavLink
              to={`/profile/developer/update`}
              className={styles.navLinks_link}
              onClick={linkClickHandle}
            >
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/profile.png")}
                alt=""
              />{" "}
              Update profile
            </NavLink>
            <NavLink
              className={styles.navLinks_link}
              onClick={() => {
                logoutclickHandle();
              }}
            >
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/logout-icon.png")}
                alt=""
              />{" "}
              Logout
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              to={`/profile/developer/${userData.userId}`}
              className={styles.navLinks_link}
              onClick={linkClickHandle}
            >
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/profile.png")}
                alt=""
              />{" "}
              Profile
            </NavLink>
            <NavLink
              to="/jobs"
              className={styles.navLinks_link}
              onClick={linkClickHandle}
            >
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/jobs-icon.png")}
                alt=""
              />{" "}
              Jobs
            </NavLink>
            <NavLink
              to="/support"
              className={styles.navLinks_link}
              onClick={linkClickHandle}
            >
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/support-icon.png")}
                alt=""
              />{" "}
              Support
            </NavLink>

            <NavLink
              className={styles.navLinks_link}
              onClick={() => {
                logoutclickHandle();
              }}
            >
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/logout-icon.png")}
                alt=""
              />{" "}
              Logout
            </NavLink>
          </>
        )}
      </section>
    </section>
  );
};

export default DevMenu;
